module.exports = __webpack_public_path__ + "static/media/8import-18.b37ca0cf.xlsx";